export default function createData (values, bornDate) {
    const data = {
        key: values.user,
        password: values.password,
        idStore: Number(values.businessId),
        idRole: Number(values.role),
        person: {
            attributes: [
                {
                    description: 'first_name',
                    value: values.name
                }, {
                    description: 'last_name',
                    value: values.lastName
                }, {
                    description: 'born_date',
                    value: bornDate,
                }, {
                    description: 'gender',
                    value: values.gender
                }
            ],
            documents: [
                {
                    idType: 1,
                    document: values.dni
                }
            ]
        },
    };
    return data;
};
